import { useClipboard } from '@chakra-ui/react'

export default useClipboard
